import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../Container';
import Image from '../Image/index.js';

const space = '10px';

export const StyledFooter = styled.footer`
  background-color: ${themeGet('colors.white')};
  padding: 60px 0 0;

  a,
  button,
  p,
  li {
    color: ${themeGet('colors.black')};
    border: none;

    &:focus,
    &:hover {
      border: none;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 75px 0 0;
  }
`;

export const Logo = styled.img`
  height: 100%;
  max-height: 37px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: 30px;
  }
`;

export const TopRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding-bottom: 0px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: calc(${space} * 5);
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const BottomRow = styled.div`
  background-color: #5b6065;
`;

// * This is the styled {UL} that contains links like Privacy policy and Terms and Conditions
export const StyledBottomContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 0;

  a {
    margin: 0 10px;
    list-style: none;

    font-size: 16px;
    letter-spacing: -0.21px;
    line-height: 30px;
    font-weight: normal;

    &:hover,
    &:focus {
      color: ${themeGet('colors.white')};
      opacity: 0.8;
    }
  }

  a,
  p {
    color: ${themeGet('colors.white')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    justify-content: flex-end;
  }
`;

export const LeftContainer = styled.div`
  width: auto;
  margin-bottom: 40px;

  a span,
  a span img {
    display: block;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-right: 75px;
    display: block;
    margin-bottom: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    margin-right: 100px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    margin-right: 150px;
  }
`;

export const LinksAndBadgesWrapper = styled.div`
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    display: flex;
    padding-bottom: 40px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding-bottom: 0px;
  }
`;

export const CenterContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 -${space};
  a {
    font-weight: normal;
    font-size: 15px;
    letter-spacing: -0.2px;
    line-height: 32px;

    &:focus,
    &:hover {
      opacity: 0.8;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-wrap: nowrap;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 650px;
  }
`;

export const Badge = styled(Image)`
  height: auto;
  width: 100%;
  max-height: 78px;
`;

export const RightContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;

  &.no-bullets {
    margin: auto;
  }

  li {
    margin: 5px 0;

    width: 50%;

    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  & li:nth-child(2) img {
    max-height: 50px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    justify-content: flex-end;
    width: 100%;
    max-width: 250px;

    && {
      margin: 0;
      margin-left: auto;
    }

    & li:nth-child(2) img {
      max-height: 78px;
    }

    li {
      margin: 5px 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 300px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${space};
  margin-bottom: 30px;

  & :nth-child(odd) {
    flex: 0 1 60%;
  }

  & :nth-child(even) {
    flex: 0 1 40%;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* This fixes IE flex calc bug */
    flex: 0 1 45%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 0;

    & :nth-child(odd),
    & :nth-child(even) {
      flex: 1 1 auto;
    }
  }
`;

export const Heading = styled.p`
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.24px;
  line-height: 21px;
  margin-bottom: 10px;
`;

export const SocialLinks = styled.div`
  position: absolute;
  bottom: 35px;
  display: flex;
  flex-direction: row;
  margin: 0 -10px;
  width: 100%;
  justify-content: center;

  a {
    &:focus,
    &:hover {
      opacity: 0.8;
    }
  }

  img {
    margin: 0 10px;
    height: 100%;
    width: 100%;
    max-height: 24px;
    max-width: 24px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    position: static;
    bottom: auto;
    width: unset;
    justify-content: left;
  }
`;
